import React, { memo, useContext, useEffect, useRef } from 'react';
import { AVContext } from '../../../../context';
const style = { width: '100%' };
const HMSVideo = ({ videoTrack }) => {
    const { av } = useContext(AVContext);
    const ref = useRef(null);
    useEffect(() => {
        const videoEl = ref.current;
        if (videoEl) {
            av.attachVideo(videoTrack, videoEl);
        }
        return () => {
            if (videoEl) {
                av.detachVideo(videoTrack, videoEl);
            }
        };
    }, [videoTrack, av]);
    return (React.createElement("video", { style: style, ref: ref, autoPlay: true, muted: true, playsInline: true, disablePictureInPicture: true }));
};
export default memo(HMSVideo);
//# sourceMappingURL=hmsVideo.js.map